import Cookies from "js-cookie";

export const removeAccessToken = (): void => {
  Cookies.set("ot_auth_token", "", { expires: -1 });
};
